import { render, staticRenderFns } from "./dtlVideo.vue?vue&type=template&id=6fff05f6&scoped=true&"
import script from "./dtlVideo.vue?vue&type=script&lang=js&"
export * from "./dtlVideo.vue?vue&type=script&lang=js&"
import style1 from "./dtlVideo.vue?vue&type=style&index=1&id=6fff05f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fff05f6",
  null
  
)

export default component.exports